// extracted by mini-css-extract-plugin
export var boxItems = "_ag-1";
export var boxItemsLg = "_ag-2";
export var button = "_ag-7";
export var buttonHoverless = "_ag-9";
export var buttonLg = "_ag-8";
export var filterGroupBox = "_ag-0";
export var icon = "_ag-3";
export var iconSecondary = "_ag-6";
export var iconWrapper = "_ag-4";
export var iconWrapperLg = "_ag-5";
export var truncatedLabel = "_ag-a";